
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $27a2f9d7c3e40b45$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"9K4jq\",\"EmojiPickerComponent.4a87966e.js\",\"haemK\",\"mobile-upload.f5ce777a.js\",\"dXN7B\",\"sha256SimpleHasher.34f3fee5.js\",\"d6s42\",\"sha256SimpleHasher.7ac16086.js\",\"fhU7k\",\"esm.fe46a0d0.js\",\"hyqsV\",\"esm.e99e8d08.js\",\"tLGOl\",\"simpleHasher.3dafbef7.js\",\"fbRdC\",\"simpleHasher.d373c337.js\",\"kAAjo\",\"simpleHasher.runtime.b5710fce.js\",\"kAAjo\",\"simpleHasher.runtime.b5710fce.js\",\"1RolH\",\"EmojiPickerComponent.a881b760.js\",\"5t3NJ\",\"basketball.06ad2e22.js\",\"ffEVr\",\"vendors~editor_icon.6a5899b8.js\",\"f1x0y\",\"flag.198afb7e.js\",\"a5PnA\",\"takeout-food.78d524e5.js\",\"ljaqI\",\"tree.8e118205.js\",\"1cGGc\",\"vehicle-car.01bcac42.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.2ac61a9d.js\",\"4S0zt\",\"EmojiPickerComponent.00cbcbdf.js\",\"6wr18\",\"vendors~editor_icon.9bace50c.js\"]"));


$parcel$global.rlb("2haIE")
//# sourceMappingURL=EmojiPickerComponent.runtime.e10942ef.js.map
